import { ColorsType } from '../types'

const choices = {
    transparent: 'transparent',
    black: '#000',
    white: '#fff',
    greyGorilla: '#2b2c2d',
    greyRhino: '#3D3D3D',
    greyElephant: '#535556',
    greyKoala: '#74787a',
    greyHippo: '#888d90',
    greyQuokka: '#b5b9ba',
    greyDolphin: '#d2d5d6',
    greySeal: '#e5e5e5',
    greyMouse: '#eaeaea',
    greyErmine: '#f4f5f5',
    westblue: '#043de2',
    westblueTint: '#0a70f3',
    indigo: '#3c62c3',
    ladybird: '#ab2b2b',
    engineRed: '#C63400',
    cricketGreen: '#2c3e02',
    java: '#13b4c3',
    hollywoodCerise: '#F400AB',
    sunshineYellow: '#E4C300',
    canaryYellow: '#FFB506',
    fantaOrange: '#FF8900',
}

export const colors: ColorsType = {
    brand: choices.westblue,
    section: choices.westblue,
    background: choices.white,
    text: {
        primary: {
            default: choices.greyGorilla,
            onDark: choices.white,
        },
        secondary: {
            default: choices.greyElephant,
            onDark: choices.white,
        },
        heading: {
            default: choices.greyGorilla,
            onDark: choices.white,
        },
    },

    actions: {
        link: {
            default: choices.greyGorilla,
            hover: choices.westblue,
            focus: choices.westblue,
            active: choices.westblue,
            onDark: {
                default: choices.white,
                hover: choices.white,
                focus: choices.white,
                active: choices.white,
            },
        },
        button: {
            text: {
                default: choices.white,
                hover: choices.white,
                focus: choices.white,
                active: choices.white,
                onDark: {
                    default: choices.white,
                    hover: choices.white,
                    focus: choices.white,
                    active: choices.white,
                },
            },
            background: {
                default: choices.westblue,
                hover: choices.greyGorilla,
                focus: choices.greyGorilla,
                active: choices.greyGorilla,
                onDark: {
                    default: choices.westblue,
                    hover: choices.greyGorilla,
                    focus: choices.greyGorilla,
                    active: choices.greyGorilla,
                },
            },
            border: {
                default: choices.greyGorilla,
                onDark: choices.white,
            },
        },
    },
}
